import styles from './hero-intro-public.module.scss';
import { Box } from "@mui/material";
import { ReactNode } from "react";
import SplitContent from "@/app/features/shared/split-content/ui/SplitContent";

interface HeroIntroPublicProps {
    content: ReactNode;
    background: ReactNode;
    baseHeight?: string;
    mobileLayout?: 'stacked' | 'overlay';
}

export default function HeroIntroPublic({
    content,
    background,
    baseHeight = '100vh',
}: HeroIntroPublicProps) {

    return (
        <Box
            className={styles.heroIntroContainer}
            sx={{
                "--base-height": baseHeight,
            }}
        >
            <SplitContent
                content={content}
                background={background}
                resizingDisabled
            />
        </Box>
    )
}
